import type { Path, TText } from 'platejs';
import { KEYS } from 'platejs';
import type { PlateEditor } from 'platejs/react';

const FIELD_MARK_KEYS = [KEYS.bold, KEYS.italic, KEYS.code] as const;

function fieldMarkTypes(editor: PlateEditor): string[] {
  return FIELD_MARK_KEYS.map((key) => editor.getType(key));
}

function isTextNode(node: unknown): node is TText {
  return typeof node === 'object' && node !== null && 'text' in node;
}

/** Clear bold/italic/code on text in a block and drop stored marks (Notion-like plain continuation). */
export function clearFieldMarksAtBlock(editor: PlateEditor, blockPath: Path) {
  const marks = fieldMarkTypes(editor);

  editor.tf.unsetNodes(marks, {
    at: blockPath,
    match: (node) => isTextNode(node),
    split: true,
  });
  editor.tf.removeMarks(marks);
}

export function clearFieldMarksOnCurrentBlock(editor: PlateEditor) {
  const block = editor.api.block();
  if (!block) return;

  clearFieldMarksAtBlock(editor, block[1]);
}
